import React from 'react';
import './App.scss';
import { Content } from 'carbon-components-react/lib/components/UIShell';
import EditorHeader from './components/EditorHeader';
import { Routes, Route } from 'react-router-dom';
import EditorPage from './content/EditorPage';

function App() {
  return (
	  <>
	    <EditorHeader />
	    <Content>
		  <Routes>
			<Route path="/" element={<EditorPage />} />
			<Route path="/content/apps/radius-editor/*" element={<EditorPage />} />
		  </Routes>
	    </Content>
	  </>
  );
}

export default App;
